import { render, staticRenderFns } from "./AddReminder.vue?vue&type=template&id=0b36ef5e&"
import script from "./AddReminder.vue?vue&type=script&lang=js&"
export * from "./AddReminder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "@/locales/components/RemindsTranslate.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2FUsers%2Flike%2FDocuments%2FComay%2FSources%2FFe%2Flink-fe%2Fsrc%2Fcomponents%2Fadd-reminder%2FAddReminder.vue"
if (typeof block0 === 'function') block0(component)

export default component.exports